import React from 'react';
import {ValueCell} from '../../../../../../components/initial-plan/ValueCell';
import {Data, HorizontalBar, Title} from '../ProjectScopingTotals_styled';
import {Tile, TileRow} from './Tile_styled';
import {BUDGET_TYPE} from '../../../../../../constants';
import {useIntl} from 'react-intl';
import {useProjectTotals} from '../ProjectScopingTotalsContext';

export const FixedPriceLeftTile = (): JSX.Element => {
	const intl = useIntl();
	const {totalsData, projectData, settings} = useProjectTotals();
	const isFixedPriceWithNoExpensesOnTop =
		projectData.budgetType === BUDGET_TYPE.FIXED_PRICE_V2 &&
		Math.abs(totalsData.projectedTotalRevenue - (projectData.budget || 0)) < 0.1;
	return (
		<Tile>
			<TileRow>
				<Title singleLine>
					{intl.formatMessage({
						id: isFixedPriceWithNoExpensesOnTop ? 'common.fixed_price' : 'common.projected_total_revenue',
					})}
				</Title>
				<Data small>
					<ValueCell
						noJustify
						cy={isFixedPriceWithNoExpensesOnTop ? 'fixed_price' : 'projected_total_revenue'}
						type={ValueCell.VALUE_TYPE.PRICE}
						value={totalsData.projectedTotalRevenue}
						currencySymbol={settings.currencySymbol}
					/>
				</Data>
			</TileRow>
			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.projected_total_cost'})}</Title>
				<Data small>
					<ValueCell
						noJustify
						cy={'projected_total_cost'}
						type={ValueCell.VALUE_TYPE.PRICE}
						value={totalsData.projectedTotalCost}
						currencySymbol={settings.currencySymbol}
					/>
				</Data>
			</TileRow>
			<HorizontalBar />

			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.projected_total_profit'})}</Title>
				<Data small>
					<ValueCell
						noJustify
						cy={'projected_total_profit'}
						type={ValueCell.VALUE_TYPE.PRICE}
						value={totalsData.projectedTotalProfit}
						currencySymbol={settings.currencySymbol}
					/>
				</Data>
			</TileRow>
			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.projected_total_margin'})}</Title>
				<Data small>
					<ValueCell
						noJustify
						cy={'projected_total_margin'}
						type={ValueCell.VALUE_TYPE.PERCENTAGE}
						value={totalsData.projectedTotalMargin}
					/>
				</Data>
			</TileRow>
		</Tile>
	);
};
